/** @format */

export const APP_NAME = "FirstCert";
export const PERSIST_STORE_NAME = "123-456";
export const STORE_VERSION = "1.0.2"; // Update this version as needed

export const REDIRECT_URL_KEY = "redirectUrl";

export const APP_VERSION = "1.0";
